import React, { useState } from 'react'
import _ from 'lodash'
import Pager from './Pager'
import TableHeaderSortable from './TableHeaderSortable'
import { rowsPerPage } from '../constants'
import PartnerClientEditor from './PartnerClientEditor'

let PartnerClientManager = ({
  searchVal,
  clients,
  sort,
  setSort,
  page,
  setPage,
}) => {
  const [editingClientIndex, setEditingClientIndex] = useState(-1)

  let THSort = ({ children, field }) => {
    return (
      <TableHeaderSortable sort={sort} setSort={setSort} field={field}>
        {children}{' '}
      </TableHeaderSortable>
    )
  }

  const filteredClients = _(clients)
    .filter(c => {
      let lowerSearchVal = _.toLower(searchVal)

      return (
        _.includes(_.toLower(c.id), lowerSearchVal) ||
        _.includes(_.toLower(c.name), lowerSearchVal)
      )
    })
    .value()

  return (
    <div>
      {filteredClients[editingClientIndex] && (
        <PartnerClientEditor
          client={filteredClients[editingClientIndex]}
          onClose={() => setEditingClientIndex(-1)}
        />
      )}
      <table className="table table-striped table-bordered table-sm small">
        <thead>
          <tr>
            <THSort field="id">ID</THSort>
            <THSort field="name">Name</THSort>
            <th>Users</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          {_(filteredClients)
            .orderBy([c => _.toLower(c[sort.field])], [sort.order])
            .value()
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((c, index) => {
              return (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{c.name}</td>
                  <td>
                    {_.map(c.users, u => (
                      <div key={u.email}>
                        {u.name} - {u.phoneNumber} - {u.email}
                      </div>
                    ))}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-secondary py-0"
                      onClick={() =>
                        setEditingClientIndex(index + rowsPerPage * page)
                      }
                    >
                      <i className="fa fa-edit" /> Add/Edit Users
                    </button>
                  </td>
                </tr>
              )
            })}
        </tbody>
      </table>
      <Pager
        page={page}
        pageCount={Math.ceil(filteredClients.length / rowsPerPage)}
        setPage={setPage}
      />
    </div>
  )
}

export default PartnerClientManager
